var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBidding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88889 1.66699H16.1111C16.4793 1.66745 16.8323 1.81393 17.0927 2.0743C17.3531 2.33466 17.4995 2.68767 17.5 3.05588V16.9448C17.4995 17.313 17.3531 17.666 17.0927 17.9264C16.8323 18.1867 16.4793 18.3332 16.1111 18.3337H3.88889C3.52067 18.3332 3.16767 18.1867 2.9073 17.9264C2.64694 17.666 2.50046 17.313 2.5 16.9448V3.05588C2.50046 2.68767 2.64694 2.33466 2.9073 2.0743C3.16767 1.81393 3.52067 1.66745 3.88889 1.66699ZM11.3889 5.83366V3.05588H8.61111V5.83366H11.3889ZM3.88889 3.05588V16.9448H16.1119L16.1111 3.05588H12.7778V7.22255H7.22222V3.05588H3.88889ZM9.44444 11.3892H5.27778V12.7781H9.44444V11.3892ZM12.2222 14.167H5.27778V15.5559H12.2222V14.167Z",
    fill: "#E9EEF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidding);
export default __webpack_public_path__ + "static/media/Bidding.47e63b11a65ab31d463e6c97a8fc1045.svg";
export { ForwardRef as ReactComponent };